'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageIndexByKey = exports.pageContentByKey = undefined;

var _sagaTools = require('@classpass/saga-tools');

var KEY = 'SAGA.API.PAGES';

var pageContentByKey = exports.pageContentByKey = (0, _sagaTools.makeEntityScaffold)(KEY + '.CONTENT', function (client, key) {
  return client.pages.getPageByKey(key).then(function (resp) {
    return resp.data;
  });
});

var pageIndexByKey = exports.pageIndexByKey = (0, _sagaTools.makeEntityScaffold)(KEY + '.INDEX', function (client, key) {
  return client.pages.getPageByKey(key).then(function (resp) {
    return resp.data;
  });
});